import { Column, Entity, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OutreachAudienceEntity } from './outreach-audience.entity';

@Entity('_outreach_audience_contact')
export class OutreachAudienceContactEntity extends BaseEntity {
	@Column('int', { name: '_fk__client__id', unsigned: true })
	public fkClientId!: number;

	@Column('varchar', { name: '_email_address', nullable: true, length: 255 })
	public emailAddress!: string | null;

	@Column('varchar', { name: '_phone_number', nullable: true, length: 20 })
	public phoneNumber!: string | null;

	@Column('json', { name: '_contact_data', nullable: true })
	public contactData!: object | null;

	@Column('enum', {
		name: '_contact_type',
		nullable: true,
		enum: ['include', 'exclude'],
		default: () => "'include'",
	})
	public contactType!: 'include' | 'exclude' | null;

	@Column('enum', {
		name: '_status',
		enum: ['active', 'unsubscribed', 'bounced', 'do_not_call'],
	})
	public status!: 'active' | 'unsubscribed' | 'bounced' | 'do_not_call';

	@ManyToOne(
		() => OutreachAudienceEntity,
		(outreachAudience) => outreachAudience.outreachAudienceContacts,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__outreach_audience__id', referencedColumnName: 'id' },
	])
	public fkOutreachAudience!: OutreachAudienceEntity;
}
